<div class="qr-scanner-container">
  <mat-card>
    <mat-card-content>
      <div class="scanner-header">
        <h3>Escaneie o QR Code</h3>
        <button mat-icon-button (click)="onClose()" class="close-button">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="scanner-content">
        <div class="camera-container" *ngIf="!error">
          <video #videoElement autoplay playsinline class="camera-video"></video>
          <canvas #canvasElement style="display: none;"></canvas>
          <div class="scanner-overlay">
            <div class="scanner-box"></div>
            <div class="scanner-status" *ngIf="scanning">
              <p>Posicione o QR Code dentro do quadrado</p>
            </div>
          </div>
        </div>

        <div *ngIf="error" class="error-message">
          <mat-icon color="warn">error</mat-icon>
          <p>{{ error }}</p>
          <button mat-raised-button color="primary" (click)="startCamera()">
            Tentar Novamente
          </button>
        </div>

        <div class="scanner-actions">
          <button mat-raised-button (click)="onClose()" color="warn">
            Cancelar
          </button>
          <button mat-raised-button (click)="simulateQRScan()" color="accent">
            Simular QR (Teste)
          </button>
        </div>

        <div class="scanner-info" *ngIf="!error">
          <p><mat-icon>info</mat-icon>
            Use o botão "Simular QR (Teste)" para testar a funcionalidade ou posicione um QR Code real na câmera.
          </p>
          <!-- <p *ngIf="hasBarcodeDetector"><mat-icon>check</mat-icon>
            Detector nativo disponível - QR codes serão detectados automaticamente.
          </p>
          <p *ngIf="!hasBarcodeDetector"><mat-icon>warning</mat-icon>
            Detector nativo não disponível - use o botão de simulação para testes.
          </p> -->
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
